function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4536 2.68815C19.3395 2.15701 20.0201 1.31598 20.3405 0.31378C19.5112 0.80564 18.5928 1.16278 17.6152 1.3552C16.8324 0.52112 15.7171 0 14.4827 0C12.1126 0 10.1909 1.92147 10.1909 4.29155C10.1909 4.6279 10.2289 4.95546 10.3021 5.2696C6.73532 5.0906 3.57298 3.38203 1.45632 0.78551C1.08688 1.41935 0.87524 2.15656 0.87524 2.94309C0.87524 4.43204 1.63287 5.74563 2.78446 6.5153C2.08102 6.4929 1.41919 6.2999 0.84062 5.97846C0.84021 5.99639 0.84021 6.0143 0.84021 6.0324C0.84021 8.1118 2.31956 9.8463 4.28282 10.2406C3.92272 10.3387 3.54357 10.3912 3.15217 10.3912C2.87563 10.3912 2.60678 10.3642 2.34469 10.3142C2.89084 12.0191 4.47576 13.26 6.35377 13.2945C4.88499 14.4457 3.0345 15.1318 1.02376 15.1318C0.67735 15.1318 0.33574 15.1114 0 15.0717C1.89926 16.2894 4.15514 17 6.57873 17C14.4726 17 18.7894 10.4605 18.7894 4.78918C18.7894 4.60314 18.7852 4.41805 18.7769 4.23395C19.6155 3.62886 20.3431 2.87302 20.9184 2.01238C20.1488 2.35373 19.3216 2.58442 18.4536 2.68815Z",
  id: "Vector",
  fillRule: "evenodd",
  stroke: "none"
});

var SvgTwitterWhite = function SvgTwitterWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "17px",
    viewBox: "0 0 21 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitterWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter_white.5d1d1749.svg";
export { ForwardRef as ReactComponent };